<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  font-size: 14px;
  color: $text-main;
  background: $bg-page;
  -webkit-font-smoothing: antialiased;
}

a {
  color: inherit;
  text-decoration: none;
}

.el-button--primary {
  background-color: $primary !important;
  border-color: $primary !important;
  &:hover {
    background-color: $primary-light !important;
    border-color: $primary-light !important;
  }
}
</style>
